import {ReactNode} from 'react'

type Props = {
  children?: ReactNode
}

export function SurveyPageLayout({children}: Props) {
  return (
    <>
      <div className='bg-white'>
        <section className='gradient-bg'>
          <div className='container' style={{maxWidth: '640px'}}>
            <div className='pt-4 pb-30'>{children}</div>
          </div>
        </section>
      </div>
    </>
  )
}
